import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('NatoGroupClass?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('NatoGroupClass/show/'+id);
    },    
    create(params) {
        return Service().post('NatoGroupClass/create', params);
    },
    update(id, params) {
        return Service().post('NatoGroupClass/update/'+id, params);
    },
    delete(id) {
        return Service().post('NatoGroupClass/delete/'+id);
    }
}